
import React from "react";
import { AuthFormContext } from "./AuthFormContext";
import { useAuthFormState } from "./useAuthFormState";
import { AuthFormContextType } from "./types";

export const AuthFormProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const authFormState = useAuthFormState();

  return (
    <AuthFormContext.Provider value={authFormState as AuthFormContextType}>
      {children}
    </AuthFormContext.Provider>
  );
};
